import styles from "./styles.module.scss";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { DatepickerContext } from "../../../../contexts/datepicker/index.context";
import { PopconfirmProps } from "./types";
import { MergedColumnType } from "../../table/utils/types";
import { TranslationContext } from "../../../../contexts/translation/index.context";
import { ModalContext } from "../../../../contexts/modal/index.context";
import { SessionContext } from "../../../../contexts/session/index.context";
import { request } from "../../../../services";
import ModalEmail from "../modal-select-mail";
//UI
import Button from "antd/lib/button";
import Popconfirm from "antd/lib/popconfirm";
import message from "antd/lib/message";
import Radio from "antd/lib/radio";
import Modal from "antd/lib/modal";
//Icons
import MailOutlined  from "@ant-design/icons/MailOutlined";
import IconSendEmail from "../../../../assets/send-email.svg";

export default function PopconfirmComponent(props: PopconfirmProps) {
  const { intl } = useContext(TranslationContext);
  const { sessionData } = useContext(SessionContext);
  const datePickerContext = useContext(DatepickerContext);
  const location = useLocation();

  const [selectedEmail, setSelectedEmail] = useState<string | null>(' ');

  useEffect(() => {
    continueProcessing(selectedEmail);
  }, [selectedEmail]);

  const info = (success: boolean, mail:string) => {
    if (!success) message.error(intl("electronic-mail-not-sent").replace("{subject}", mail ?? ""));
  };
  const continueProcessing = async (email: string | null) => {
    if (!email || email === ' ') return;
    if (props.sendAll) 
      for (const item of datePickerContext.tableDataValue.find((item) => item?.url ===  location.pathname)?.tableData || [] as MergedColumnType[]) 
        await checkEntry(email, item);
    else await checkEntry(email,sessionData);
  };

  const checkEntry = async (email: string, data: any) => {
    if (data?.sended) {
      await Modal.confirm({
        title: intl("question-resend-electronic-mail")
          .replace("{subject}", data?.subject)
          .replace("{address}", data?.address),
        okText: intl("ok"),
        cancelText: intl("cancel"),
        onOk: async () => {
          await sendMail(email, data);
        },
        onCancel: () => {
          info(false, data?.subject);
        },
      });
      return;
    }

    await sendMail(email, data);
  };

  const sendMail = async (email: string, data: any) => {
    const success = (
      await request(`${location.pathname}/sendElectronicMail`, {
        method: "post",
        body: {
          id: data?.id,
          email: email,
          address_to: data?.address,
          subject: data?.subject,
          body_text: data?.body_text,
        },
        cancelTokenKey: "sendElectronicMail",
      })
    )?.success;
    info(success, data?.subject);
  };

  return (
    <ModalEmail
      name={props.sendAll? "send-letters": "send-letter"}
      popmessage={props.sendAll? intl("question-send-electronic-mails"): intl("question-send-electronic-mail")}
      setEmail={setSelectedEmail}
      icon={props.sendAll? ( <img
        src={IconSendEmail}
        alt="Icon"
        style={{
          width: "20px",
          height: "20px",
        }}
      />): <MailOutlined />}
    />
  );
}